import * as pdfjsLib from 'pdfjs-dist';
import pdfWorker from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;

/**
 * Render PDF first page to canvas at given dimensions (fit within, preserve aspect ratio)
 */
export async function renderPdfFirstPageToCanvas(
    file: File,
    targetWidth: number,
    targetHeight: number
): Promise<string> {
    const arrayBuffer = await file.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
    const page = await pdf.getPage(1);
    const viewport = page.getViewport({ scale: 1 });

    const scale = Math.min(
        targetWidth / viewport.width,
        targetHeight / viewport.height
    );
    const scaledViewport = page.getViewport({ scale });

    // Render at higher internal resolution for crisper thumbnails on HiDPI displays.
    const pixelRatio = 2;

    const canvas = document.createElement('canvas');
    canvas.width = Math.floor(scaledViewport.width * pixelRatio);
    canvas.height = Math.floor(scaledViewport.height * pixelRatio);
    const ctx = canvas.getContext('2d');

    if (!ctx) {
        throw new Error('Failed to get canvas context');
    }

    // Keep drawing coordinates in logical units while using a denser backing store.
    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, scaledViewport.width, scaledViewport.height);

    const renderContext = {
        canvasContext: ctx,
        viewport: scaledViewport,
    };
    await page.render(renderContext).promise;

    return canvas.toDataURL('image/png');
}
